module.exports = __webpack_public_path__ + "static/media/Marios_Pafitis.8774e6c3.png";